{
  "title": "Putaway Management",
  "subtitle": "Shelve QC-cleared / directly-accepted stock into its confirmed warehouse location.",
  "confirm": "Confirm Putaway",
  "table": {
    "grn": "GRN Number",
    "material": "Material",
    "batch": "Batch No",
    "qty": "Qty",
    "progress": "{{allocated}} of {{total}} put away",
    "warehouse": "Warehouse",
    "suggested": "Suggested Location",
    "status": "Status"
  },
  "dialog": {
    "title": "Confirm Putaway",
    "subtitle": "GRN {{grn}} · Qty {{qty}}",
    "barcodeMode": "This item was printed with GRN barcode labels — assign a zone/rack location to each one below.",
    "splitMode": "No GRN barcode labels for this item — split the quantity across as many zone/rack locations as needed.",
    "locationType": "Location Type",
    "typeAll": "All",
    "typeZone": "Zone",
    "typeRack": "Rack",
    "typeBin": "Bin",
    "zone": "Zone",
    "assignAllLocation": "Assign Location to All",
    "assignAllLocationHelper": "Applies this zone/rack to every barcode row below — you can still change individual rows afterward.",
    "itemCode": "Item Code",
    "itemName": "Item Name",
    "barcode": "Barcode",
    "scanBarcode": "Scan Barcode",
    "scanBarcodeHelper": "Scan or type this label's barcode to confirm you're shelving the physical unit in hand.",
    "scannedOfTotal": "{{scanned}} / {{total}}",
    "scanMismatch": "Doesn't match",
    "noBarcodeBlocked": "Barcode Required is enabled in Process Configuration, but this item has no printed GRN labels. Print labels for this item before putaway can be confirmed.",
    "rowN": "Split {{n}}",
    "location": "Zone / Rack / Bin",
    "addRow": "Split / Add Row",
    "selectAll": "Select All",
    "allocatedOf": "Selected: {{allocated}} of {{total}} remaining",
    "mismatchHint": "Selected quantity can't exceed the {{total}} remaining.",
    "exactMismatchHint": "A manual quantity split must add up to exactly {{total}} — partial confirms are only supported for barcode-linked items.",
    "alreadyPutAway": "{{allocated}} of {{total}} already put away in a previous save.",
    "confirmPartial": "Confirm Selected ({{count}})",
    "remarks": "Remarks"
  },
  "cancel": "Cancel"
}
